import React, { useEffect, useState, useContext, useRef } from 'react';
import ContentHeader from './ContentHeader';
import Header from './Header';
import Footer from './Footer';
import PolarCareHeader from './PolarCareHeader';
import AlsamartHeader from './AlsamartHeader';
import ShipBookingHeader from './ShipBookingHeader';
import "primereact/resources/themes/lara-light-blue/theme.css";
//import "primereact/resources/themes/bootstrap4-light-blue/theme.css";

function Layout ({
        page_title='', 
        menu="", 
        breadcrumbs=true, 
        children, 
        parent_link='', 
        parent_text='',
        containerClass="container-fluid"
    }){
    const base_root = window.location.host

    function DisplayHeader(){
        if(base_root === "polarcare.polar-air.com" || base_root === "polarcare-staging.polar-air.com"){
            return <PolarCareHeader menu={menu} />
        }
        else if(base_root === "alsamart.com" || base_root === "dev.alsamart.com"){
            return <AlsamartHeader menu={menu} />
        }
        else if(base_root === "ogs.topventory.com" || base_root === "ogs.daroy.net"){
            return <ShipBookingHeader menu={menu} />
        }

        return <ShipBookingHeader menu={menu} />
        return <Header menu={menu} />
    }
    
    return (
        <div>
            {/* {
                base_root === "polarcare.polar-air.com" || base_root === "polarcare-staging.polar-air.com" ?
                <PolarCareHeader menu={menu} /> : <Header menu={menu} />
            } */}
            <DisplayHeader />

            <div className="content-wrapper pb-3">
                <ContentHeader title={page_title} breadcrumbs={breadcrumbs}  parent_link={parent_link} parent_text={parent_text} containerClass={containerClass} />
                
                <section className="content">
                    {children}
                </section>

            </div>

            <Footer />
        </div>
    )
}
 
export default Layout;